import React from 'react';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import * as api from '../api';
declare var __portal: IPortalSettings;
declare var __promo_json: IPromoObj;

@observer
export default class PromoRedeem extends React.Component {
    constructor(props) {
        super(props);
        this.save = this.save.bind(this);
    }

    @action
    save = async () => {
        api.redeemCode();
    };

    render() {
        if (__promo_json.redeemAvailable === false) {
            return <div />;
        } else {
        }

        return (
            <div
                className="redeem-code"
                role="button"
                aria-label={`Redeem promo code ${__promo_json.redeemCode} for ${__promo_json.redeemOff}`}
                onClick={this.save}
                tabIndex={0}
            >
                <div>
                    <span
                        className="lb lb-blue"
                        style={{padding: '6px 12px'}}
                    >
                        Redeem
                    </span>
                    <span>{__promo_json.redeemOff}</span>
                    <span>
                        with code <b>{__promo_json.redeemCode}</b>
                    </span>
                </div>
            </div>
        );
    }
}
